import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=0a320721&scoped=true&"
import script from "./transfer.vue?vue&type=script&lang=ts&"
export * from "./transfer.vue?vue&type=script&lang=ts&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=0a320721&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a320721",
  null
  
)

export default component.exports